//#region IMPORTS
import { TranslationLanguage } from "../../models/translations";
import { useEffect, useState } from "react";
import { ArrowDownCircleIcon } from "@heroicons/react/20/solid";
import { useTranslation } from "react-i18next";
import { XCircleIcon } from "@heroicons/react/24/outline";
import TranslationDropDownList from "./TranslationDropdownList";
import "./TranslationDropdown.css";
//#endregion

//#region INTERFACE
interface Props {
  availableLanguages: TranslationLanguage[];
}
//#endregion

export default function TranslationDropdown({ availableLanguages }: Props) {
  //#region SETUP
  // Translation
  const { i18n, t } = useTranslation();

  // Local State
  const [open, setOpen] = useState<boolean>(false);
  const [selectedLanguageCode, setSelectedLanguageCode] = useState<string>(
    i18n.language
  );
  const [selectedLanguageName, setSelectedLanguageName] = useState<string>(
    i18n.language
  );
  //#endregion

  //#region LOGIC
  useEffect(() => {
    const foundLanguage = availableLanguages.find(
      (lang) => lang.code === i18n.language
    );
    foundLanguage && setSelectedLanguageName(foundLanguage.name);
  }, [availableLanguages, i18n]);

  // Select handler
  const handleSelectLanguage = async (language: TranslationLanguage) => {
    setSelectedLanguageCode(language.code);
    setSelectedLanguageName(language.name);
    localStorage.setItem("robinLanguage", language.code);
    await i18n.changeLanguage(language.code);
    closeHandler();
  };

  // Open handler
  const openHandler = () => {
    !open && setOpen(true);
  };

  // Close handler
  const closeHandler = () => {
    open && setOpen(false);
  };
  //#endregion

  //#region RENDER
  return (
    <div className="dropdown">
      <p className="dropdown__name">{t("rituals.portalLanguage")}</p>
      <div className="dropdown__cta">
        <h3 className="dropdown__cta__title serif">{selectedLanguageName}</h3>
        <button onClick={open ? closeHandler : openHandler} className="z-50">
          {open ? (
            <XCircleIcon className="text-gray-950 w-6 h-6" />
          ) : (
            <ArrowDownCircleIcon className="text-gray-400 w-6 h-6" />
          )}
        </button>
      </div>

      {/* Drop down menu */}
      {open && (
        <TranslationDropDownList
          selectedValue={selectedLanguageCode}
          languages={availableLanguages}
          onChange={(language) => handleSelectLanguage(language)}
        />
      )}
    </div>
  );
  //#endregion
}
